import { render, staticRenderFns } from "./DraftRegistration.vue?vue&type=template&id=4f34aab1&scoped=true&"
import script from "./DraftRegistration.vue?vue&type=script&lang=js&"
export * from "./DraftRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DraftRegistration.vue?vue&type=style&index=0&id=4f34aab1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34aab1",
  null
  
)

export default component.exports